<template lang="pug">
  .home-page
    .container(v-observe-visibility="inViewport" data-anim="fade-in" data-anim-delay="650")
      h1.title.title_size_l.home-page__title Каршеринг BelkaCar
      p.home-page__desc Более 2000 автомобилей в&nbsp;Москве и&nbsp;Сочи
      a.btn.btn_theme_blue.btn_size_m.home-page__btn.hide-mob(href="#") Начать поездки

      slick.car-slider(ref="slick" :options="slickOptionsMain" @beforeChange="handleBeforeChange")
        - n = 4
        - for(var i = 0; i < n; i++)
          .car-slider-item
            .car-slider-item__content
              .car-slider-item__row
                .car-slider-item__info
                  h2.title.title_size_m.car-slider-item__title Mercedes-Benz СLA
                  p.text.car-slider-item__text Передвигайтесь по&nbsp;городу на&nbsp;автомобиле премиум-класса, сочетающем комфорт, стиль и&nbsp;легкость управления.
                  a.btn.btn_size_s.car-slider-item__btn(href="#") Подробнее о тарифе
                .car-slider-item__image.show-mob
                  img(src="/static/img/car.png", alt="")
                .car-slider-item__price
                  .car-price-item
                    h3.car-price-item__title Поездка
                    p.car-price-item__text #[span.car-price-item__text_opacity от]#[span.car-price-item__text_num 11]₽/мин
                  .car-price-item
                    h3.car-price-item__title Ожидание
                    p.car-price-item__text #[span.car-price-item__text_opacity от] #[span.car-price-item__text_num 3] ₽/мин

            .car-slider-item__image.hide-mob
              img(src="/static/img/car.png", alt="")
      .car-slider-thumb-outer
        p.car-selector Наши машины в #[span.car-selector__city Москве]#[i.icon-arrow-down]
        slick.car-slider-thumb(ref="slick" :options="slickOptionsNav")
          - n = 4
          - for(var i = 0; i < n; i++)
            .car-slider-thumb-item
              img(src="/static/img/car-thumb@2x.png", alt="")
      a.btn.btn_theme_blue.btn_size_m.home-page__btn.show-mob(href="#") Начать поездки

    section.news-section
      .container(v-observe-visibility="inViewport" data-anim="fade-in" data-anim-delay="650")
        .news-section__social
          social
          .news-section__social-descriptor

        .news-section__row
          h2.news-section__title Новости
          .news-section-list
            a.news-section-item(href="#")
              .news-section-item__content
                p.news-section-item__text Самый ожидаемый блокбастер этого лета! Сегодня на дороги вышли 150 новых KIA Rio X-Line и 100 Mercedes…
                time.news-section-item__date 12 Июля 2018
              .news-section-item__image
                img(src="/static/img/news-car.jpg", alt="")
            a.news-section-item(href="#")
              .news-section-item__content
                p.news-section-item__text Самый ожидаемый блокбастер этого лета! Сегодня на дороги вышли 150 новых KIA Rio X-Line и 100 Mercedes…
                time.news-section-item__date 12 Июля 2018
              .news-section-item__image
                img(src="/static/img/news-car.jpg", alt="")
          a.news-section__more(href="#") Больше новостей

    section.advantages-section
      .container
        h2.title.title_size_m.advantages__title(v-observe-visibility="inViewport" data-anim="fade-in" data-anim-delay="650") Наши преимущества
        .advantages-list
          .advantages-item.advantages-item_free-parking(v-observe-visibility="inViewport")
            .advantages-item__content(data-anim="fade-in" data-anim-delay="650")
              h3.title.title_size_m.advantages-item__title Бесплатный московский паркинг
              p.text.advantages-item__text Не думайте об&nbsp;оплате парковки, просто паркуйтесь в&nbsp;разрешенном для&nbsp;этого месте.
            .advantages-item__image(data-anim="fade-in" data-anim-delay="850")
              img(src="/static/img/free-parking.svg", alt="")

          .advantages-item.advantages-item_kasko(v-observe-visibility="inViewport")
            .advantages-item__content(data-anim="fade-in" data-anim-delay="650")
              h3.title.title_size_m.advantages-item__title Все автомобили застрахованы по&nbsp;КАСКО
              p.text.advantages-item__text Минимальные выплаты при&nbsp;ДТП по&nbsp;вине клиента. Просто соблюдайте правила сервиса.
            .advantages-item__image(data-anim="fade-in" data-anim-delay="850")
              img.hide-laptop(src="/static/img/kasko.svg", alt="")
              img.show-laptop(src="/static/img/kasko-laptop.svg", alt="")

          .advantages-item.advantages-item_personal-parking(v-observe-visibility="inViewport")
            .advantages-item__image(data-anim="fade-in" data-anim-delay="850")
              img(src="/static/img/personal-parking.svg", alt="")
            .advantages-item__content(data-anim="fade-in" data-anim-delay="650")
              h3.title.title_size_m.advantages-item__title Отдельные парковки в&nbsp;аэропортах
              p.text.advantages-item__text Бесплатные парковки в&nbsp;Шереметьево, Внуково, Домодедово и&nbsp;Жуковском, отведенные специально для&nbsp;наших машин

          .advantages-item.advantages-item_clearfix

          .advantages-item.advantages-item_petrol(v-observe-visibility="inViewport")
            .advantages-item__content(data-anim="fade-in" data-anim-delay="650")
              h3.title.title_size_m.advantages-item__title Бензин включен в&nbsp;стоимость
              p.text.advantages-item__text Оплачивайте бензин по&nbsp;топливным картам и&nbsp;получайте компенсацию за&nbsp;время, проведенное на&nbsp;АЗС.
            .advantages-item__image(data-anim="fade-in" data-anim-delay="850")
              img(src="/static/img/petrol.svg", alt="")

          .advantages-item.advantages-item_area(v-observe-visibility="inViewport")
            .advantages-item__content(data-anim="fade-in" data-anim-delay="650")
              h3.title.title_size_m.advantages-item__title Зоны завершение аренды и&nbsp;паркинга
              p.text.advantages-item__text Не&nbsp;думайте об&nbsp;оплате парковки, просто паркуйтесь в&nbsp;разрешенном для&nbsp;этого месте.
            .advantages-item__image(data-anim="fade-in" data-anim-delay="850")
              img(src="/static/img/area.svg", alt="")

          .advantages-item.advantages-item_tech(v-observe-visibility="inViewport")
            .advantages-item__content(data-anim="fade-in" data-anim-delay="650")
              h3.title.title_size_m.advantages-item__title Техническая поддержка 24/7
              p.text.advantages-item__text Оплачивайте бензин по&nbsp;топливным картам и&nbsp;получайте компенсацию за&nbsp;время, проведенное на&nbsp;АЗС.
            .advantages-item__image(data-anim="fade-in" data-anim-delay="850")
              img(src="/static/img/tech.svg", alt="")

    section.cta-carshering-section(v-observe-visibility="inViewport")
      .container
        h2.title.title_size_l.cta-carshering-section__title(data-anim="fade-left" data-anim-delay="950") Начни пользоваться каршерингом уже&nbsp;сейчас
        .cta-carshering
          .cta-carshering__image
            .android(data-anim="long-fade-in" data-anim-delay="650")
              img(src="/static/img/android.png", alt="")
            .iphone(data-anim="long-fade-down" data-anim-delay="650")
              img(src="/static/img/iphone.png", alt="")
          .cta-carshering__info
            .app-list.cta-carshering__app-list(data-anim="fade-left" data-anim-delay="950")
              a.app-list__link(href="#")
                i.icon-playmarket
              a.app-list__link(href="#")
                i.icon-appstore
            .cta-carshering__content(data-anim="fade-right" data-anim-delay="950")
              h3.title.title_size_m.cta-carshering__title Регистрируйтесь прямо сейчас
              p.text.cta-carshering__text Для этого понадобятся паспорт, водительские права, 5 минут вашего времени и&nbsp;никакого залога. Мы&nbsp;рады приветствовать граждан РФ и&nbsp;иностранцев от&nbsp;21&nbsp;года со&nbsp;стажем вождения от&nbsp;2&nbsp;лет
              a.btn.btn_size_m.btn_theme_blue.cta-carshering__btn(href="#") Начать поездки

</template>

<script>
import Slick from 'vue-slick'
import Social from './../components/Social'

export default {
  name: 'HomePage',
  components: { Slick, Social },
  data () {
    return {
      slickOptionsMain: {
        infinite: false,
        slidesToShow: 1,
        speed: 750,
        // autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        dots: true,
        draggable: false,
        pauseOnHover: false,
        asNavFor: '.car-slider-thumb',
        waitForAnimate: false
      },
      slickOptionsNav: {
        infinite: false,
        slidesToShow: 1,
        arrows: false,
        asNavFor: '.car-slider',
        variableWidth: true,
        focusOnSelect: true,
        centerMode: true,
        waitForAnimate: false,
        draggable: false,
        centerPadding: '35%'
      }
    }
  },
  methods: {
    handleBeforeChange: function (event, slick, currentSlide, nextSlide) {
      // alert('before')
      // console.log('handleBeforeChange', event, slick, currentSlide, nextSlide)
    },
    inViewport (isVisible, entry) {
      this.$nextTick(function () {
        if (entry.isIntersecting) {
          const element = entry.target
          element.classList.add('in-view')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/HomePage.vue